import React, {Component} from 'react';
import { connect } from '../../utils';
import Media from './Media';
import CarouselList from './carousel';

class CarouselView extends Component{
  render(){
    const {id,layoutState} = this.props;
    const {imageUrl , altText, auto, interval,  direction} = layoutState.getItemJS(id).props.values;
    let srcMobile = [];
    let srcDesktop = [];
    if(imageUrl){
      srcMobile = (imageUrl.urlMobile.length > 0) ? imageUrl.urlMobile : imageUrl.url;
      if(srcMobile.length === 0){
        srcMobile = ["https://via.placeholder.com/1028x1028?text=400x400=CMS"]
      };
      srcDesktop = (imageUrl.url.length > 0) ? imageUrl.url : imageUrl.urlMobile;
      if(srcDesktop.length === 0){
        srcDesktop = ["https://via.placeholder.com/1028x1028?text=600x600=CMS"];
      };
    }

    return(
      <div style={{
      boxSizing: 'border-box',
      position: 'relative',
      height: 'auto',
      display: 'flex',
      width:'100%',
      justifyContent: 'center',
      flex:1,
    }}>
      <Media query="(max-width: 768px)">
        {matches =>
          matches ? <CarouselList photos={srcMobile} alt={altText} auto={auto} interval={interval}  direction={direction } /> : <CarouselList photos={srcDesktop} alt={altText} auto={auto} interval={interval}  direction={direction}  />}
      </Media>
    </div>
    )
  }
}

export default connect('layoutState')(CarouselView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/CarouselView.js